export default __webpack_public_path__ + "static/media/14.cb3b2a31.jpg";